module.exports = __webpack_public_path__ + "static/avatar_jim-b6b34fba36d8472af85cec26bff512d5.png";